export function sanitizeSpaces(text: string): string {
  return typeof text === 'string' ? text.replace(/\s+/g, ' ').trim() : text;
}
